const configurationFunction = function () {
  if (!process.env.APP_ENV) {
    process.env.APP_ENV = 'development'
  }
  
  const configuration = {
    development: {
      websocketsUrl: process.env.WEB_SOCKET_URL || 'wss://websockets.apihost.trainerday.com',
      apiUrl: process.env.API_URL || 'http://localhost:8090',
      sentryUrl: process.env.SENTRY_DSN || ''
    },
    stage: {
      websocketsUrl: process.env.STAGE_WEBSOCKET_URL || 'wss://websockets-svc.uat.trainerday.com',
      apiUrl: process.env.STAGE_API_URL || 'https://web-trainer-api.uat.trainerday.com',
      sentryUrl: process.env.SENTRY_DSN || 'https://af9142b2b442483d9fa7ead5002e2d6a@errors.trainerday.com/8'
    },
    production: {
      websocketsUrl: process.env.PRODUCTION_WEBSOCKET_URL || 'wss://websockets.apihost.trainerday.com',
      apiUrl: process.env.PRODUCTION_API_URL || 'https://web-trainer-api.prod.trainerday.com',
      sentryUrl: process.env.SENTRY_DSN || 'https://5c4d1ac3d5a043c1b2f4fbcfc3db9d80@errors.trainerday.com/21'
    }
  }
  return configuration[process.env.APP_ENV]
}

export default configurationFunction()